function deleteImageAnalysisRule(rule_id) {
  return fetch(`${process.env.REACT_APP_API_ENDPOINT}/image-analysis`, {
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      rule_id: `${rule_id}`,
    },
  })
    .then((response) => response.json())
    .then((responseJSON) => {
      return responseJSON;
    });
}

export default deleteImageAnalysisRule;
